<template>
  <div>
    <header id="header">
      <div class="container">
        <div class="row">
          <div class="col-6">
            <a href="/" class="logo">
              <img :src="config.logo.logo_with_icon"/>
            </a>
          </div>
          <div class="col-6 text-right">
            <router-link tag="a" to="login" class="login">
              <span class="tw-flex tw-flex-col tw-justify-center">
                <div class="tw-text-center"><img class="tw-inline-block" src="/overt/img/login.svg" /></div>
                <div>Login</div>
              </span>
            </router-link>
          </div>
        </div>
      </div>
    </header>

    <section class="hero">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-xl-4 col-lg-8 align-self-center">
            <h2>{{lang.header}}</h2>
            <p>{{lang.introductory}}</p>
          </div>
        </div>
      </div>

      <div class="illustration-1">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-2">
        <div class="img"></div>
        <div class="border"></div>
      </div>
    </section>

    <section class="action">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h3 class="mb-4">{{lang.header_services}}</h3>
          </div>
          <div class="col-lg-4">
            <div class="card inleveren">
              <h4>{{lang.card_return_car.header}}</h4>
              <div class="card-footer">
                <a
                  @click="onAccodionItemClick"
                  class="btn btn-sm btn-secondary"
                  data-toggle="collapse"
                  href="#inleveren"
                  aria-expanded="false"
                  aria-controls="inleveren"
                  >{{lang.card_return_car.btn}}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card inleverlocaties">
              <h4>{{lang.card_drop_off_location.header}}</h4>
              <div class="card-footer">
                <a
                @click="onAccodionItemClick"
                  class="btn btn-sm btn-secondary"
                  data-toggle="collapse"
                  href="#search"
                  aria-expanded="false"
                  aria-controls="search"
                  >{{lang.card_drop_off_location.btn}}</a
                >
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card contact">
              <h4>{{lang.card_contact.header}}</h4>
              <div class="card-footer">
                <a class="btn btn-sm btn-secondary" href="#contact"
                  >{{lang.card_contact.btn}}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section ref="accordion" class="accordion" id="accordion-parrent">
      <div class="container">
        <div class="row">
          <div class="col">
            <div
              class="collapse"
              id="inleveren"
              data-parent="#accordion-parrent"
            >
              <div class="card">
                <div class="card-header">
                  <a
                    class="close"
                    data-toggle="collapse"
                    data-target="#inleveren"
                    aria-expanded="false"
                    aria-controls="inleveren"
                  >
                    <span></span>
                  </a>
                  <h2>{{lang.card_return_car.form.header}}</h2>
                </div>
                <div class="card-body">
                  <p>{{lang.card_return_car.form.introductory}}</p>
                  <form class="mt-5">
                    <div class="row">
                      <div class="col-md-4">
                        <input
                          ref="license_plate"
                          type="text"
                          class="form-control license_plate"
                          name="license_plate"
                          :placeholder="lang.card_return_car.form.input_license_plate"
                          v-model="licensePlate"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                        ref="conked_out_license_plate"
                          type="text"
                          class="form-control"
                          name="conked_out_license_plate"
                          :placeholder="lang.card_return_car.form.input_license_plate_customer"
                          @keyup.prevent.enter="handleSignOffVehicle"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                          type="button"
                          class="btn btn-primary"
                          :value="lang.card_return_car.form.btn_submit"
                          @click="handleSignOffVehicle"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div class="collapse" id="search" data-parent="#accordion-parrent">
              <div class="card">
                <div class="card-header">
                  <a
                    class="close"
                    data-toggle="collapse"
                    data-target="#search"
                    aria-expanded="false"
                    aria-controls="search"
                  >
                    <span></span>
                  </a>
                  <h2>{{lang.card_drop_off_location.form.header}}</h2>
                </div>
                <div class="card-body">
                  <p>{{lang.card_drop_off_location.form.introductory}}</p>
                  <form class="mt-5">
                    <div class="row">
                      <div class="col-md-4">
                        <input
                          autofocus
                          type="text"
                          class="form-control"
                          :placeholder="lang.card_drop_off_location.form.input_license_plate"
                          v-model="returnLicensePlate"
                          @keydown.prevent.enter="handleFindReturnDepots"
                        />
                      </div>
                      <div class="col-md-4">
                        <input
                          type="button"
                          class="btn btn-primary return_license_plate"
                          :value="lang.card_drop_off_location.form.btn_submit"
                          @click="handleFindReturnDepots"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-xl-4 col-lg-8 align-self-center">
            <h2 class="text-white">{{lang.nutshell.header}}</h2>
            <p class="text-white">{{lang.nutshell.introductory_1}}</p>
            <p class="text-white">{{lang.nutshell.introductory_2}}</p>
          </div>
        </div>
      </div>

      <div class="illustration-3">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-4">
        <div class="img"></div>
        <div class="border"></div>
      </div>

      <div class="illustration-5">
        <div class="img"></div>
        <div class="border"></div>
      </div>
    </section>

    <section class="footer">
      <div class="portal wow animeted fadeInLeft"></div>
      <div class="container h-100">
        <div class="row h-100">
          <div class="col-lg-4 col-md-8 offset-lg-8 align-self-center">
            <h2>{{lang.back_on_the_road.header}}</h2>
            <p>{{lang.back_on_the_road.introductory}}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="contact">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2 text-left text-md-center">
            <h3>{{lang.contact.header_1}}</h3>
            <h3>{{lang.contact.header_2}}</h3>
          </div>
          <div class="col-md-6 text-left text-md-right my-lg-5 mb-4">
            <a :href="`tel:${config.company.phone_formatted}`" class="btn btn-primary"
              >{{ config.company.phone }}</a
            >
          </div>
          <div class="col-md-6 my-lg-5 mb-5">
            <a :href="`mailto:${config.company.email_rent}`" class="btn btn-primary"
              >{{ config.company.email_rent }}</a
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  name: "landing",
  data() {
    return {
      licensePlate: "",
      returnLicensePlate: "",
      lang: i18n.app.components.welcome
    };
  },
  mounted() {

    const vueClass = this;

    jQuery(function($) {
      const hash = window.location.hash;
      var header = $("#header");

      $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 100) {
          header.addClass("scroll");
        } else {
          header.removeClass("scroll");
        }
      });

      // init WOW
      new WOW().init();

      // Parallax
      $(window).scroll(function(e) {
        parallax();
      });

      function parallax() {
        listOfItems();
      }

      function addItem(item, speed, direction) {
        let scrolled = $(window).scrollTop();
        item.css(direction, -(scrolled * speed) + "px");
      }

      function listOfItems() {
        addItem($(".illustration-4"), 0.1, "margin-top");
        addItem($(".illustration-2"), 0.5, "margin-top");
        addItem($(".illustration-3"), 0.3, "margin-top");
      }

      // Smooth scroll
      $('a[href*="#"]:not([href="#"]):not([data-toggle])').click(function() {
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          var target = $(this.hash);
          vueClass.scrollToElement(target)
        }
      });

      if (hash) {
        const element = document.getElementById(hash.replace('#', ''));

        if (element) {
          const $element = jQuery(element);
          $element.click();

          if ($element.hasClass('collapse')) {
            $element.addClass('show')
          }
        }
      }
    });
  },
  methods: {

    scrollToElement($element) {
      $element = $element.length
          ? $element
          : $("[name=" + this.hash.slice(1) + "]");
        if ($element.length) {
          $("html, body").animate(
            {
              scrollTop: $element.offset().top
            },
            1000
          );
          return false;
        }
    },

    onAccodionItemClick(event) {
      this.scrollToElement(
        jQuery(this.$refs.accordion)
      )
    },

    async handleSignOffVehicle() {
      const success = await this.checkLicensePlate(this.licensePlate);
      if (success) {
        location.href = `/sign-off-form?license_plate=${this.licensePlate}`;
      } else {
        $(".license_plate").addClass("license-error");
      }
    },
    async handleFindReturnDepots() {
      const success = await this.checkLicensePlate(this.returnLicensePlate);
      if (success) {
        location.href = `/return-locations`;
      } else {
        $(".return_license_plate").addClass("license-error");
      }
    },
    async checkLicensePlate(licensePlate) {
      if (licensePlate !== "") {
        return await axios
          .post("/sign-off/check-license-plate", {
            license_plate: licensePlate
          })
          .then(() => true)
          .catch(() => false);
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "*/overt/scss/main.scss";

.logo {
  img {
    max-height: 77px;
  }
}
</style>
